<template>
  <div class="filtro-form">
    <label class="form__label clickable" @click="mostrarFiltros = !mostrarFiltros">
      <i class="fas fa-fw fa-filter"/>
      <span>&nbsp;Filtrar por estado</span>
    </label>
    <section v-show="mostrarFiltros">
      <div class="grid grid--padding filtro-form__opciones" >
        <div class="col-md-12">
          <div class="checkbox">
            <input type="checkbox" id="nuevo" v-model="filtro.estado" value="nuevo">
            <label class="form__label" for="nuevo">Nuevo</label>
          </div>
          <div class="checkbox">
            <input type="checkbox" id="aprobado" v-model="filtro.estado" value="aprobado">
            <label class="form__label" for="aprobado">Aprobado</label>
          </div>
          <div class="checkbox">
            <input type="checkbox" id="rechazado" v-model="filtro.estado" value="rechazado">
            <label class="form__label" for="rechazado">Rechazado</label>
          </div>
        </div>
      </div>
      <button
      type="button"
      class="boton boton--s boton--buscar"
      @click="$emit('filtrar', 1, filtro)"/>
    </section>
  </div>
</template>

<script>
export default {
  name: "FiltroFormulario",
  data,
};

function data() {
  return {
    filtro: {
      estado: ["nuevo", "aprobado", "rechazado"],
      inspector: this.$store.state.usuario.usuario._id,
    },
    mostrarFiltros: false,
  };
}
</script>

<style lang="scss">
@import "~Sass/variables";
.filtro-form {
  padding: 13px;
  background: $celeste-claro-tema;
}
.filtro-form__opciones {
  padding: .5em;
  .checkbox {
    margin-bottom: .5em;
  }
}
</style>
